import { render } from "./PageNavigation.vue?vue&type=template&id=ee5a2576&scoped=true"
import script from "./PageNavigation.vue?vue&type=script&lang=js"
export * from "./PageNavigation.vue?vue&type=script&lang=js"

import "./PageNavigation.vue?vue&type=style&index=0&id=ee5a2576&scoped=true&lang=css"

import exportComponent from "/Users/k.belov/Programming/sites/gl_site/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee5a2576"]])

export default __exports__